export const sanitizeTechnologyItem = (item = {}) => {
  const { sources, evidence_list, ...rest } = item;
  return rest;
};

export const sanitizeTechnologyAnalyzeResponse = (payload) => {
  if (!payload || typeof payload !== 'object') {
    return payload;
  }

  if (!Array.isArray(payload.data)) {
    return payload;
  }

  return {
    ...payload,
    data: payload.data.map(sanitizeTechnologyItem),
  };
};

export const formatTechnologyValue = (value) => {
  if (value === null || value === undefined || value === '' || value === 'null') {
    return '-';
  }

  return value;
};
